import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { logsReducer } from './reducers/logsReducer'
import { usersReducer } from './reducers/usersReducer'
import { chatbotReducer } from './reducers/chatbotReducer'
import { productsReducer } from './reducers/productsReducer'
import { departmentsReducer } from './reducers/departmentsReducer'
import { productHistoryReducer } from './reducers/productHistoryReducer'
import { productTemplateReducer } from './reducers/productTemplateReducer'
import { delegationsReducer } from './reducers/delegationsReducer'
import { productStateReducer } from './reducers/productStateReducer'

const intialState = {}
const appReducer = combineReducers({
    users: usersReducer,
    chatbot: chatbotReducer,
    logs: logsReducer,
    products: productsReducer,
    departments: departmentsReducer,
    productHistory: productHistoryReducer,
    productTemplates: productTemplateReducer,
    delegations: delegationsReducer,
    productStates: productStateReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    reducer,
    intialState,
    composeEnhancer(applyMiddleware(thunk))
)

export default store
